import { PureComponent, type ReactElement, type ReactNode } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';

interface OurErrorBoundaryProps {
  // attributes
  readonly children: ReactElement;
  readonly fallback?: ReactNode;
}

export class OurErrorBoundary extends PureComponent<OurErrorBoundaryProps> {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  state = {
    hasError: false
  };

  // componentDidCatch(/* error, info */) {
  //   ...additional error handling...
  // }

  render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;
    return (hasError ? fallback || <div></div> : children) as ReactNode;
  }
}

const ErrorBoundary = window.SENTRY_DSN ? SentryErrorBoundary : OurErrorBoundary;

export default ErrorBoundary;
